function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -996.36)",
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.1 1026.4h43v24h-43zM5.1 1019.4h47v7h-47z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.1 1026.4h5v24h-5zM17.444 1004.5c-2.11.019-3.946.616-4.875 1.313-4 3 1.828 6.754 6.312 9.187 4.52 2.451 6.385 3.021 7.782 3.469a2.5 2.5 0 01-.563-1.563c0-.299.06-.577.156-.843-.68-.333-2.69-1.393-5.687-3.47-4.066-2.816-5.546-3.917-4-5 2-1.399 5.074.323 7 2.626 1.927 2.304 2.632 4.456 2.875 5.437a2.477 2.477 0 011.875-1.218c-.32-1.985-1.05-4.094-2.75-6.22-2.25-2.812-5.413-3.742-8.125-3.718zM39.756 1004.5c-2.712-.024-5.875.906-8.125 3.719-1.7 2.125-2.43 4.234-2.75 6.218.804.092 1.488.55 1.875 1.22.243-.982.948-3.134 2.875-5.438 1.926-2.303 5-4.025 7-2.625 1.546 1.082.066 2.183-4 5-2.997 2.076-5.007 3.135-5.688 3.468.097.267.157.545.157.844a2.5 2.5 0 01-.563 1.563c1.397-.448 3.263-1.018 7.781-3.469 4.485-2.433 10.312-6.188 6.313-9.188-.929-.696-2.765-1.293-4.875-1.312z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.037 1009.5s-.94 2.122-1.656 3.406c-.64 1.15-1.844 2.594-1.844 2.594 7.973 4.35 14.416 3.63 22.563 3.844a2.496 2.496 0 01-1.25-.657h-.03c-4.5-1.272-12.466-4.214-17.782-9.187zm20.22 9.813a2.388 2.388 0 01-.282.062c.21.01.413-.01.625 0a22.76 22.76 0 01-.343-.062zm.343.062c.459.078.722.105.625.03-.215-.01-.412-.022-.625-.03z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.162 1009.5c-5.317 4.973-13.281 7.915-17.781 9.188h-.031c-.337.33-.77.558-1.25.656 8.146-.214 14.59.505 22.562-3.844 0 0-1.204-1.444-1.844-2.594-.715-1.284-1.656-3.406-1.656-3.406zm-20.219 9.813c-.106.02-.256.048-.344.062.212-.01.415.01.625 0a2.607 2.607 0 01-.281-.062zm-.344.062l-.625.03c-.097.074.167.046.625-.03z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28.6,
  cy: 1016.9,
  r: 2.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.1 1019.4h5v7h-5z"
}));

var SvgGift = function SvgGift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Gift.995132cd.svg";
export { ForwardRef as ReactComponent };